import React, { useState, useEffect, useRef } from "react";
import {
  Layout,
  ConfigProvider,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
} from "antd";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../../../components/layouts/MainLayout";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import { connect, useDispatch } from "react-redux";
import TopContent from "../../../../components/layouts/TopContent";
import { onSelectItemAction, rightAction } from "../../../../redux/actions";
import DownloadTableButtons from "../../../../components/DownloadTableButtons";
import {
  manageTaxComponentsAPI,
  manageTaxComponentsLabel,
  manageTaxComponentsStatic,
} from "./taxComponents.config";

//global distructures
const { Text, Link, Title } = Typography;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Percentage",
    dataIndex: "percentage",
  },
];

const PRD01300 = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;

  const { session } = userData;
  const [taxComponentsList, setTaxComponentsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();

  //DECLARED METHODS

  useEffect(() => {
    BOM.HasPermission("READ_TAXCOMPONENT") && getTaxComponentListAction();
    BOM.HasPermission("CREATE_TAXCOMPONENT") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getTaxComponentListAction = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, manageTaxComponentsAPI.ManageTaxComponents, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            name: element?.name ? element?.name : "-",
            percentage: element?.percentage ? element?.percentage : "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setTaxComponentsList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, manageTaxComponentsAPI.ManageTaxComponents, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              name: element?.name ? element?.name : "-",
              percentage: element?.percentage ? element?.percentage : "-",
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_TAXCOMPONENT") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_TAXCOMPONENT") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      if (item)
        dispatch({
          type: item,
        });
    });
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setTaxComponentsList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) => item?.key === parseInt(searchKey) || item?.name.toLowerCase()?.includes(searchKey)
    );
    setTaxComponentsList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-prd1300", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-prd1300", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-prd1300", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={manageTaxComponentsLabel.manageTaxComponents}
        pageItems={manageTaxComponentsStatic.manageTaxComponentSetupItems}
      />

      {/* RENDER TABLE LIST */}
      <Card
        title={"Manage Tax Components List"}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name..."
                style={{
                  width: 400,
                }}
              />
            </div>
            <DownloadTableButtons
              downloadData={taxComponentsList}
              columns={columns}
              fileName={"Tax Components List"}
              onExportClick={getCsvListData}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={taxComponentsList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(PRD01300);
